import { render } from "./SendConfirmMail.vue?vue&type=template&id=73587351&scoped=true"
import script from "./SendConfirmMail.vue?vue&type=script&lang=js"
export * from "./SendConfirmMail.vue?vue&type=script&lang=js"

import "./SendConfirmMail.vue?vue&type=style&index=0&id=73587351&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73587351"]])

export default __exports__